import React from 'react'
import '@fontsource/ruda' // Defaults to weight 400.
import '@fontsource/tinos' // Defaults to weight 400.
import '@fontsource/bebas-neue' // Defaults to weight 400.
import '@fontsource/inter' // Defaults to weight 400.
import '@fontsource/montserrat' // Defaults to weight 400.

export default class FontFamilies extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: props.filter,
      active: props.active || 'Ruda',
      values: [
        { id: 1, name: 'ruda', text: 'Aa', value: 'Ruda' },
        { id: 2, name: 'tinos', text: 'Aa', value: 'Tinos' },
        { id: 3, name: 'bebas-neue', text: 'AA', value: 'Bebas Neue' },
        { id: 4, name: 'inter', text: 'Aa', value: 'Inter' },
        { id: 5, name: 'montserrat', text: 'Aa', value: 'Montserrat' },
        { id: 6, name: 'rubik', text: 'Aa', value: 'Rubik' },
        { id: 7, name: 'quicksand', text: 'Aa', value: 'Quicksand' },
      ],
    }
  }

  render() {
    let { values, active } = this.state
    return (
      <div style={this.props.containerStyle} className="font-families">
        {values.map((item) => (
          <div
            key={item.id}
            className={`font font-${item.name} ${
              active === item.value ? 'active' : ''
            }`}
            onClick={() =>
              this.setState({ active: item.value }, () => {
                this.props.onFontChanged(item.value)
              })
            }
          >
            <span>{item.text}</span>
          </div>
        ))}
      </div>
    )
  }
}
